import * as React from 'react';

import Alert from 'src/components/common/Alert';
import Input from 'src/components/common/Input';
import { IAddress, addressUSA, addressCA } from './validAddresses';

import AddressModel from 'src/model/address.model';
import addressServiceInstance from 'src/services/address/AddressService';
import Select2 from 'src/components/common/Select2';
import env from 'src/shared/env';

import './OneTimeAddress.scss';
import Dropdown from 'src/components/common/Dropdown';
import { IOption } from 'src/components/common/Dropdown/Dropdown';

interface IOneTimeAddressProps {
  handleClicDeliverAddress(
    address: AddressModel,
    oneTimeAddress: boolean
  ): void;
  t?: any;
}

interface IOneTimeAddressState {
  customerName: string;
  country: string;
  address: string;
  addressOptional: string;
  city: string;
  stateCode: string;
  zipCode: string;
  showDropDown: boolean;
  selectedState: IAddress;
  error: { hasFailed: boolean; message: string };
}

class OneTimeAddress extends React.Component<
  IOneTimeAddressProps,
  IOneTimeAddressState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      customerName: '',
      country: env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'Canada' : 'USA',
      address: '',
      addressOptional: '',
      city: '',
      stateCode:
        env.REACT_APP_BASE_ENVIRONMENT === 'CA'
          ? addressCA[0].value || ''
          : addressUSA[0].value || '',
      selectedState:
        env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? addressCA[0] : addressUSA[0],
      zipCode: '',
      showDropDown: false,
      error: { hasFailed: false, message: '' }
    };
  }

  private handleInputCustomerNameChange = (customerName: string) => {
    this.setState({
      customerName
    });
  };

  private handleInputAddressChange = (address: string) => {
    this.setState({
      address
    });
  };

  private handleInputAddressOptionalChange = (addressOptional: string) => {
    this.setState({
      addressOptional
    });
  };

  private handleInputCityChange = (city: string) => {
    this.setState({
      city
    });
  };

  private handleInputStateChange = (selectedOptionValue: string) => {
    this.setState({
      selectedState: {
        name:
          addressUSA.find(state => state.value === selectedOptionValue)?.name ||
          addressCA.find(state => state.value === selectedOptionValue)?.name,
        value: selectedOptionValue
      },
      stateCode: selectedOptionValue
    });
  };

  private handleInputZipCodeChange = (zipCode: string) => {
    this.setState({
      zipCode
    });
  };

  private handleClicDeliverAddress = (e: any) => {
    e.preventDefault();
    const address: AddressModel = {
      country: this.state.country,
      name: this.state.customerName,
      number: 0,
      postalCode: this.state.zipCode,
      addressLine1: this.state.address,
      addressLine2: this.state.addressOptional,
      addressLine3: '',
      addressLine4: this.state.city,
      countryCode: '',
      stateCode: this.state.stateCode,
      taxJurisdiction: ''
    };
    if (this.state.customerName.length > 0) {
      addressServiceInstance
        .validateOneTimeAddress(
          null,
          address.addressLine4,
          null,
          address.stateCode,
          address.addressLine1,
          address.addressLine2,
          address.postalCode
        )
        .then(res => {
          address.postalCode = res[0].zipCode;
          address.addressLine4 = res[0].city;
          address.stateCode = res[0].state;
          address.addressLine1 = res[0].street;
          this.props.handleClicDeliverAddress(address, true);
        })
        .catch(error => {
          this.setState({
            error: {
              hasFailed: true,
              message: 'Invalid address.'
            }
          });
        });
    } else {
      this.setState({
        error: {
          hasFailed: true,
          message: 'Please enter customer name'
        }
      });
    }

    // if (this.state.country === 'USA') {
    //   addressServiceInstance
    //     .validateOneTimeAddress(
    //       null,
    //       address.addressLine4,
    //       null,
    //       address.stateCode,
    //       address.addressLine1,
    //       address.addressLine2,
    //       address.postalCode
    //     )
    //     .then(res => {
    //       address.postalCode = res[0].zipCode;
    //       address.addressLine4 = res[0].city;
    //       address.stateCode = res[0].state;
    //       address.addressLine1 = res[0].street;
    //       this.props.handleClicDeliverAddress(address, true);
    //     })
    //     .catch(error => {
    //       this.setState({
    //         error: {
    //           hasFailed: true,
    //           message: 'Invalid address.'
    //         }
    //       });
    //     });
    // } else {
    //   this.props.handleClicDeliverAddress(address, true);
    // }
  };

  private formattedStateOptions = (statesList: IAddress[]): IOption[] => {
    return statesList.map(({ name, value }) => ({ label: name, value }));
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-one-time-address">
        {this.state.error.hasFailed && (
          <Alert
            styleClass="rp-one-time-address--alert"
            message={this.state.error.message}
            icon={'rpds-error'}
            handleCloseAlert={() => {
              return;
            }}
            type={'error'}
          />
        )}
        <div className="rp-one-time-address--title">
          {t('common.or')} {t('product.enterOneTimeAddress')}:
        </div>
        <form className="rp-one-time-address--form">
          <div className="rp-one-time-address--form-inputs">
            <Input
              label={`${t('accountShippingAddress.customerName')}:`}
              type="text"
              maxLength={30}
              value={this.state.customerName}
              invalid={this.state.customerName.length === 30}
              invalidMessage={t('product.customerNameAddress')}
              onChange={this.handleInputCustomerNameChange}
              required={true}
              name="name"
              autoComplete="name"
            />
          </div>
          <div className="rp-one-time-address--form-inputs">
            <Input
              label={`${t('accountShippingAddress.address')}:`}
              type="text"
              maxLength={30}
              placeholder={t('accountShippingAddress.addressPlaceholder')}
              value={this.state.address}
              onChange={this.handleInputAddressChange}
              required={true}
              invalid={this.state.address.length === 30}
              invalidMessage={t('product.customerNameAddress1')}
              autoComplete="Street address"
              name="Street address"
            />
            <Input
              type="text"
              maxLength={30}
              placeholder={t('accountShippingAddress.suiteTxt')}
              value={this.state.addressOptional}
              onChange={this.handleInputAddressOptionalChange}
              invalid={this.state.addressOptional.length === 30}
              invalidMessage={t('product.customerNameAddress2')}
            />
          </div>
          <div className="rp-one-time-address--form-inputs">
            <Input
              label={
                env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? `${t('accountShippingAddress.postalCode')}:`
                  : `${t('accountShippingAddress.zipOrPostal')}:`
              }
              type="text"
              maxLength={12}
              value={this.state.zipCode}
              onChange={this.handleInputZipCodeChange}
              required={true}
              invalid={this.state.zipCode.length === 12}
              invalidMessage={t('product.customerNameAddress3')}
              autoComplete="PIN code"
              name="PIN code"
            />
          </div>
          <div className="rp-one-time-address--form-inputs">
            <Input
              label={`${t('accountShippingAddress.city')}:`}
              type="text"
              maxLength={30}
              value={this.state.city}
              onChange={this.handleInputCityChange}
              required={true}
              invalid={this.state.city.length === 30}
              invalidMessage={t('product.customerNameAddress4')}
              autoComplete="address-level2"
              name="address-level2"
            />
          </div>
          <div className="rp-one-time-address--form-inputs">
            <label className="rp-one-time-address-state-label">
              *{t('accountShippingAddress.stateOrProvince')}:
            </label>
            <Dropdown
              options={
                this.state.country === 'USA'
                  ? this.formattedStateOptions(addressUSA)
                  : this.formattedStateOptions(addressCA)
              }
              activeOption={this.state.selectedState.value}
              onSelected={this.handleInputStateChange}
            />
          </div>
          <div className="rp-one-time-address--form-inputs">
            <label>{t('accountShippingAddress.country')}:</label>
            <div className="rp-one-time-address-country">
              {this.state.country}
            </div>
          </div>
          <button
            className="primary-button rp-one-time-address--form-button"
            onClick={this.handleClicDeliverAddress}
          >
            {t('product.deliverToAddress')}
          </button>
        </form>
      </div>
    );
  }
}

export default OneTimeAddress;
